import React from 'react';
import '../../styles/table-main/main.css';

const Main = () => {
    return (
        <div id='tableMain'>
            <div className="table-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">
                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading mb-4">University News Letter</h2>
                                {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Title</th>
                                                <th>View</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>THE INSIGHT (Oct-Dec 2022)</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/THE-INSIGHT-4.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            View
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>THE INSIGHT (Jul-Sep 2022)</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/THE-INSIGHT-3.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            View
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>THE INSIGHT (Apr-Jun 2022)</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/THE-INSIGHT-II-2022.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            View
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>THE INSIGHT (Jan-Mar 2022)</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/the-insight_news-letter.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            View
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>THE INSIGHT (Jan-Mar 2023)</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/THE-INSIGHT-5.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            View
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>THE INSIGHT (Apr-Jun 2023)</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/apr-june-2023.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            View
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>THE INSIGHT (Jun- Sep 2023)</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/insught-jul-sep-2023.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            View
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>THE INSIGHT (Oct - Dec 2023)</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/THE%20INSIGHT%20(Oct%20-%20Dec%20%202023).pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            View
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;